import {useQuery, UseQueryResult} from '@tanstack/react-query';

import {fetchAspects, getAspectUrl} from './review-aspect-api';
import {AspectsType} from './review-aspect-type';

export function useAspects(q: string, aspectIds?: Array<number>): UseQueryResult<Array<AspectsType>> {
    return useQuery([getAspectUrl(q, aspectIds)], () => fetchAspects(q, aspectIds));
}
